import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        flex: 1,
        marginTop: 64,
    },

   rowContainer: {
    marginTop: 32,
    flexDirection: 'row',
    justifyContent: 'flex-start', 
    flexWrap: 'wrap'
},

    colContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
    },

    title: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
    },

    rowBox: {
        marginTop: 16,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 12
    },

    colBox: {
        width: "30%",
        alignItems: 'center',
        marginBottom: 48
    },

    image: {
        width: 247,
        height: 247,
        borderRadius: 24,
    },

    projectTitle: {
        fontSize: 18,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700', 
        marginTop: 24
    },

    projectLocalisation: {
        fontSize: 18,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '600', 
        marginTop: 20
    },

    projectText: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 20,
        textAlign: 'justify',
    },

    bulletContainer: {
        display: "flex",
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 6,
        fontFamily: "Montserrat"
    },

    previousProjectTitle: {
        marginTop: 14,
        color: 'rgb(83, 83, 83)',
        fontFamily: 'Montserrat',
        fontWeight: "600",
        fontSize: 18
    },

    previousProjectDescription: {
        marginTop: 24,
        fontFamily: 'Montserrat',
        textAlign: 'justify',
        color: 'rgb(83, 83, 83)',
        fontSize: 16
    },

    bulletImage: {
        width: 24,
        height: 24
    },

    bulletText: {
        marginLeft: 12,
        fontSize: 14,
        fontFamily: 'Montserrat',
        fontWeight: '400',
        color: '#535353',
    }
});